import React from 'react'
import PropTypes from 'prop-types'
import keymirror from 'keymirror'
import classnames from 'classnames'
import _ from 'lodash'
import MediaQuery from 'react-responsive'

import styles from './styles.module.scss'

function renderContent(property, render, data, truncate, isRowHover) {
  let dataProperty = property ? _.get(data, property) : data

  if (truncate && typeof dataProperty === 'string') {
    dataProperty = _.truncate(dataProperty, {
      length: truncate,
      omission: '…',
    })
  }

  return render ? render(dataProperty, { data, isRowHover }) : dataProperty
}

const Cell = ({
  render,
  data,
  property,
  label,
  size,
  align,
  verticalAlign,
  width,
  minWidth,
  nowrapText,
  textTransform,
  truncate,
  isRowHover,
  hideOnMobile,
  hideLabelOnMobile,
  className,
}) => {
  const cellStyles = classnames(
    styles.cell,
    styles[size],
    styles[align],
    styles[verticalAlign],
    styles[textTransform],
    {
      [styles.nowrap]: nowrapText,
      [styles.mobileWidth]: width, // Cell with width take 100% of the row in small screen
    },
    className,
  )

  const content = (
    <div className={cellStyles} style={{ width, minWidth: minWidth || width }}>
      {!hideLabelOnMobile && (
        <MediaQuery maxWidth={480}>
          <div className={styles.label}>{label}</div>
        </MediaQuery>
      )}

      {renderContent(property, render, data, truncate, isRowHover)}
    </div>
  )

  return hideOnMobile ? <MediaQuery minWidth={481}>{content}</MediaQuery> : content
}

Cell.sizes = keymirror({
  normal: null,
  large: null,
})

Cell.align = keymirror({
  right: null,
  center: null,
  left: null,
})

Cell.verticalAlign = keymirror({
  top: null,
  middle: null,
  bottom: null,
})

Cell.textTransform = keymirror({
  capitalize: null,
  uppercase: null,
  lowercase: null,
  none: null,
})

Cell.defaultProps = {
  size: Cell.sizes.normal,
  align: Cell.align.left,
  verticalAlign: Cell.verticalAlign.middle,
  width: undefined,
  minWidth: undefined,
  truncate: undefined,
  nowrapText: true,
  textTransform: Cell.textTransform.none,
  property: undefined,
  data: undefined,
  label: undefined,
  render: undefined,
  className: undefined,
  isRowHover: false,
  hideOnMobile: false,
  hideLabelOnMobile: false,
}

Cell.propTypes = {
  size: PropTypes.oneOf(Object.keys(Cell.sizes)),
  verticalAlign: PropTypes.oneOf(Object.keys(Cell.verticalAlign)),
  align: PropTypes.oneOf(Object.keys(Cell.align)),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  truncate: PropTypes.number,
  nowrapText: PropTypes.bool,
  textTransform: PropTypes.oneOf(Object.keys(Cell.textTransform)),
  property: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]), // eslint-disable-line react/no-unused-prop-types
  render: PropTypes.func,
  className: PropTypes.string,
  isRowHover: PropTypes.bool,
  hideOnMobile: PropTypes.bool,
  hideLabelOnMobile: PropTypes.bool,
}

export { renderContent }

export default Cell
